import HttpClient from "libs/utils/HttpClient";
import qs from "qs";

class MasterService {
  async getAllMasterData(configs) {
    const params = qs.stringify(configs);
    try {
      const response = await HttpClient.get(`/api/master/list?${params}`);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async getExchangeRate(period, currencyCode) {
    try {
      const response = await HttpClient.get(
        `/api/master/exchangerate/list?period=${period}&currencyCode=${currencyCode}`
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }
}

export default new MasterService();
